import React, { useState, useEffect } from 'react';
import styles from './AssignOrderModal.module.css';
import myAxios from '../AxiosUrl';
import { toast } from 'react-toastify';

function AssignOrderModal({ setAssignOpen, data, setRefresh, setSelectedItems }) {
    const uid = localStorage.getItem('id');
    const [loading, setLoading] = useState(false);
    const [teamMembers, setTeamMembers] = useState([]);
    const [selectedMemberId, setSelectedMemberId] = useState('');

    useEffect(() => {
        // Fetch team members
        const url = `get-team/${uid}`;
        myAxios
            .get(url)
            .then((res) => {
                setTeamMembers(res.data || []);
            })
            .catch((error) => {
                console.error('Error fetching team members:', error);
                toast.error('Failed to load team members');
            });
    }, [uid]);

    const handleAssign = () => {
        if (!selectedMemberId) {
            toast.warning('Please select a team member');
            return;
        }

        setLoading(true);
        setRefresh(false);

        const url = `re-assign/${uid}`;
        myAxios
            .post(url, { Assign: selectedMemberId, data })
            .then((res) => {
                toast.success('Orders assigned successfully!');
                setLoading(false);
                setAssignOpen(false);
                setRefresh(true);
                setSelectedItems([]);
            })
            .catch((error) => {
                console.error('Error assigning orders:', error);
                toast.error('Failed to assign orders');
                setLoading(false);
            });
    };

    return (
        <div className={styles.modalOverlay} onClick={() => setAssignOpen(false)}>
            <div className={styles.modalBox} onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className={styles.modalHeader}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div className={styles.headerIcon}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                            </svg>
                        </div>
                        <div>
                            <h2 className={styles.headerTitle}>Assign Orders</h2>
                            <p className={styles.headerSubtitle}>
                                {data?.length === 1
                                    ? '1 order selected'
                                    : `${data?.length || 0} orders selected`}
                            </p>
                        </div>
                    </div>
                    <button className={styles.closeBtn} onClick={() => setAssignOpen(false)}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                    </button>
                </div>

                {/* Content */}
                <div className={styles.modalContent}>
                    <p className={styles.description}>
                        Select a team member to assign the selected orders. The assigned member will be responsible for processing these orders.
                    </p>

                    <div className={styles.selectGroup}>
                        <label htmlFor="teamMember" className={styles.selectLabel}>
                            Team Member
                        </label>
                        <select
                            id="teamMember"
                            className={styles.selectInput}
                            onChange={(e) => setSelectedMemberId(e.target.value)}
                            value={selectedMemberId}
                        >
                            <option value="">Select Member</option>
                            {teamMembers.map((member) => (
                                <option key={member._id} value={member._id}>
                                    {member.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Show selected orders info */}
                    {data && data.length > 0 && (
                        <div className={styles.ordersInfo}>
                            <div className={styles.infoLabel}>Orders to be assigned:</div>
                            <div className={styles.ordersList}>
                                {data.slice(0, 5).map((order) => (
                                    <div key={order._id} className={styles.orderItem}>
                                        <span className={styles.orderInvoice}>#{order.InvoiceId}</span>
                                        <span className={styles.orderCustomer}>{order.cName}</span>
                                    </div>
                                ))}
                                {data.length > 5 && (
                                    <div className={styles.moreOrders}>
                                        +{data.length - 5} more orders
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>

                {/* Actions */}
                <div className={styles.modalActions}>
                    <button
                        className={styles.cancelButton}
                        onClick={() => setAssignOpen(false)}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button
                        className={styles.assignButton}
                        onClick={handleAssign}
                        disabled={loading || !selectedMemberId}
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                            <polyline points="22 4 12 14.01 9 11.01" />
                        </svg>
                        {loading ? 'Assigning...' : 'Assign Orders'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default AssignOrderModal;
